export default "__VITE_ASSET__EP0$xHdU__"